<h1 mat-dialog-title class="col-12 dialogTitle">{{data.dialogTitle}}</h1>

<mat-form-field class="col-12">
  <input matInput [(ngModel)]="data.email" placeholder="Email" [disabled]="data.dialogMode=='edit'">
</mat-form-field>
<mat-form-field class="col-6">
  <input matInput [(ngModel)]="data.firstName" placeholder="First Name">
</mat-form-field>

<mat-form-field class="col-6">
  <input matInput [(ngModel)]="data.lastName" placeholder="Last Name">
</mat-form-field>

<mat-form-field class="col-12">
  <input matInput [(ngModel)]="data.orgName" placeholder="Organization">
</mat-form-field>

<mat-form-field class="col-12">
  <mat-label>Role</mat-label>
  <mat-select [(value)]="data.role" placeholder="Role">
    <mat-option *ngFor="let role of data.roles" [value]="role">
      {{role}}
    </mat-option>
  </mat-select>
</mat-form-field>


<mat-slide-toggle class="example-margin"
                  [(ngModel)]="data.active">
  Active
</mat-slide-toggle>

<div [ngClass]="{'col-12': data.dialogMode === 'edit', 'col-12 hidden':data.dialogMode === 'add' }">
  <mat-slide-toggle class="example-margin"
                    [(ngModel)]="data.isChangePassword">
    Change Password
  </mat-slide-toggle>
  <mat-form-field [ngClass]="{'col-12': data.isChangePassword === true, 'col-12 hidden':data.isChangePassword === false }">
    <input matInput [(ngModel)]="data.newPassword" placeholder="New Password">
  </mat-form-field>
  <mat-error [ngClass]="{'newpassword-error': data.isChangePassword === true && (data.newPassword == null || onValidatePassword(data.newPassword)), 'hidden':data.isChangePassword === false || (data.newPassword != null && onValidatePassword(data.newPassword)) }">
    New Password must meet below complexity requirements:<br /><br />
    Minimum 8 characters length<br />
    Must have at least one uppercase ('A-Z')<br />
    Must have at least one digit ('0-9') <br />
    Must have at least one non alphanumeric character
  </mat-error>
</div>


<div class="col-12 mb-3">
  <mat-dialog-actions align="end">
    <button class="dialog-user-CancelButton" mat-raised-button (click)="onClickCancel()">Cancel</button>
    <button class="dialog-user-SaveButton" mat-raised-button color="primary" [mat-dialog-close]="data" [disabled]="data.isChangePassword==true && (data.newPassword == null || !onValidatePassword(data.newPassword))" cdkFocusInitial>Ok</button>
  </mat-dialog-actions>
</div>
